module.exports = __webpack_public_path__ + "img/1678762309227-E6RP8z2R.056043bf.png";